import { Box } from '@mui/material'
import { GridColDef } from '@mui/x-data-grid-premium'
import { useMemo } from 'react'
import { BaseTable } from 'Features/Table/BaseTable.view'
import {
  ProductionCapacityRowType,
  ProductionCapacityTableProps,
} from './SystemOfRecords.types'

export const ProductionCapacityTable = ({
  data,
  isLoading,
  updateTableData,
  workCentreCode,
  isUploading,
  uploadProductionCapacity,
  isSaving = false,
}: ProductionCapacityTableProps & { isSaving?: boolean }) => {
  const columns: GridColDef[] = useMemo(
    () => [
      {
        headerName: 'ISO week',
        field: 'ISOWeek',
        flex: 1,
        type: 'number',
      },
      {
        headerName: 'ISO year',
        field: 'ISOYear',
        flex: 1,
        type: 'number',
      },
      {
        headerName: 'Work centre code',
        field: 'WorkCentreCode',
        flex: 1,
        type: 'string',
      },
      {
        headerName: 'Work centre promised capacity hours',
        field: 'WorkCentrePromisedCapacityHours',
        flex: 1,
        type: 'number',
        editable: true,
      },
    ],
    [data, workCentreCode]
  )

  return (
    <Box
      sx={{
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
        height: '100%',
        minHeight: 0,
      }}
    >
      <BaseTable
        data={data}
        columns={columns}
        isLoading={isLoading}
        updateTableData={updateTableData}
        uploadData={uploadProductionCapacity}
        isUploading={isUploading}
        isSaving={isSaving}
        checkBoxSelection={true}
        showTableToolBar={true}
        pinnedColumns={['ISOWeek', 'ISOYear', 'WorkCentreCode']}
        downloadFileName="ProductionCapacity"
      />
    </Box>
  )
}
